import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
});

class PhasesListCheck extends React.Component 
{ 
 

  render() {
    const { classes } = this.props; 
    return (
      <List className={classes.root}>
        <h1>Project Phases</h1>
        {this.props.phases.map(phase => (
          <ListItem key={phase.phase} role={undefined} dense button onClick={this.props.handleToggle(phase)}>
            <Checkbox
              checked={phase.checked === true}
              tabIndex={-1}
              disabled={this.props.reviewActive}
            />
            <ListItemText primary={`${phase.name}`} />
          </ListItem>
        ))}
      </List>
    );
  }
}

PhasesListCheck.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PhasesListCheck);


// WEBPACK FOOTER //
// ./src/features/common/PhasesListCheck.js